import(/* webpackMode: "eager" */ "/vercel/path0/web/app/cartografico.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/next/dist/client/link.js");
